import React, { Component } from 'react';
import Login from './Login';
import DashMain from './DashMain';
import '../style/layout.css';

export default class Dash extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: false
        };

        this.props.app.on('account', this.onAccountChanged.bind(this));
    }

    onAccountChanged(account) {
        this.setState({account});
    }

    render() {
        if (this.state.account) {
            return <DashMain account={this.state.account} app={this.props.app} />;
        } else {
            return <Login app={this.props.app} />
        }
    }
}




// WEBPACK FOOTER //
// ./src/ui/Dash.jsx